const isPrescriptionValue = (value)=>typeof value === 'number'
;
const BOOK_APPOINTMENT = 'book-appointment';
function isBookAppointmentEntrySelection(prescription) {
    return prescription === BOOK_APPOINTMENT;
}

export { isBookAppointmentEntrySelection, isPrescriptionValue };
//# sourceMappingURL=types.js.map
